import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  excerpt: string;
  categorySlug: string;
  categoryName: string;
  imageUrl: string;
  date: string;
  readTime: string;
  views: number;
  featured?: boolean;
}

export default function ArticleCard({
  id,
  title,
  excerpt,
  categorySlug,
  categoryName,
  imageUrl,
  date,
  readTime,
  views,
  featured,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
      <Link to={`/article/${id}`} className="block">
        <div className="relative overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            title={`${title} - 猫咪视频大全`}
            className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
              featured ? 'h-52 md:h-64' : 'h-48'
            }`}
            loading="lazy"
          />
          <div className="absolute top-3 left-3">
            <Link
              to={`/category/${categorySlug}`}
              className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-500/90 text-white hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              {categoryName}
            </Link>
          </div>
        </div>
        <div className="p-4 md:p-5">
          <h3 className="font-heading text-base md:text-lg font-bold text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">
            {title}
          </h3>
          <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
            {excerpt}
          </p>
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {readTime}
            </span>
            <span className="flex items-center gap-1 ml-auto">
              <i className="ri-eye-line"></i>
              {views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}